/**
 * Wishlist — StratOS Premium Theme
 * Pure localStorage, aucune app tierce.
 * Events: wishlist:updated(handles[])
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'stratos-wishlist';

  /* ── Core ── */
  var Wishlist = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch (_) { return []; }
    },
    save: function (list) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (_) {}
      window.pubsub && window.pubsub.publish('wishlist:updated', list);
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: list }));
    },
    has: function (handle) {
      return this.get().indexOf(handle) !== -1;
    },
    add: function (handle) {
      var list = this.get();
      if (list.indexOf(handle) === -1) { list.push(handle); this.save(list); }
    },
    remove: function (handle) {
      var list = this.get().filter(function (h) { return h !== handle; });
      this.save(list);
    },
    toggle: function (handle) {
      this.has(handle) ? this.remove(handle) : this.add(handle);
    },
    count: function () { return this.get().length; }
  };

  window.StratOSWishlist = Wishlist;

  /* ── Render wishlist buttons ── */
  function renderButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var handle = btn.dataset.wishlistBtn;
      if (!handle) return;
      var active = Wishlist.has(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active
        ? (btn.dataset.labelRemove || 'Retirer des favoris')
        : (btn.dataset.labelAdd    || 'Ajouter aux favoris')
      );
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* ── Click delegation ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.wishlistBtn;
    if (!handle) return;
    Wishlist.toggle(handle);
    renderButtons();
  });

  /* ── Update count badge ── */
  function renderCount() {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      var count = Wishlist.count();
      el.textContent = count;
      el.classList.toggle('is-hidden', count === 0);
    });
  }

  document.addEventListener('wishlist:updated', function () {
    renderButtons();
    renderCount();
  });

  /* ── Wishlist page rendering ── */
  var pageEl = document.querySelector('[data-wishlist-page]');
  if (pageEl) {
    renderWishlistPage(pageEl);
  }

  function renderWishlistPage(container) {
    var handles = Wishlist.get();
    var emptyEl = container.querySelector('[data-wishlist-empty]');
    var gridEl  = container.querySelector('[data-wishlist-grid]');

    if (!handles.length) {
      if (emptyEl) emptyEl.removeAttribute('hidden');
      if (gridEl)  gridEl.innerHTML = '';
      return;
    }

    if (emptyEl) emptyEl.setAttribute('hidden', '');

    /* Fetch products in parallel via /products/{handle}.js */
    var promises = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (products) {
      if (!gridEl) return;
      var html = '';
      var anyValid = false;
      products.forEach(function (p, i) {
        if (!p) {
          /* Produit supprimé du catalogue */
          html += '<div class="wishlist-card wishlist-card--unavailable">'
            + '<div class="wishlist-card__media wishlist-card__media--placeholder"></div>'
            + '<div class="wishlist-card__info">'
            + '<p class="wishlist-card__unavailable">Ce produit n\'est plus disponible.</p>'
            + '<button type="button" class="button button--ghost wishlist-card__remove" data-wishlist-btn="' + handles[i] + '" aria-label="Retirer des favoris">'
            + heartIcon(true) + ' Retirer'
            + '</button>'
            + '</div>'
            + '</div>';
          return;
        }
        anyValid = true;
        /* Responsive image : on génère deux tailles via Shopify CDN */
        var imgBase = p.featured_image || '';
        var img200  = imgBase ? imgBase.replace(/(\.[^.?]+)(\?.*)?$/, '_200x$1$2') : '';
        var img400  = imgBase ? imgBase.replace(/(\.[^.?]+)(\?.*)?$/, '_400x$1$2') : '';
        var img800  = imgBase ? imgBase.replace(/(\.[^.?]+)(\?.*)?$/, '_800x$1$2') : '';
        var imgTag  = imgBase
          ? '<img src="' + img400 + '" srcset="' + img200 + ' 200w, ' + img400 + ' 400w, ' + img800 + ' 800w" sizes="(min-width:1024px) 25vw, (min-width:768px) 33vw, 50vw" alt="' + escapeHtml(p.title) + '" loading="lazy" width="400" height="533">'
          : '';
        var price = p.price_min ? (p.price_min / 100).toFixed(2).replace('.', ',') + '\u00a0€' : '';
        html += '<div class="wishlist-card">'
          + '<a href="' + p.url + '" class="wishlist-card__media">' + imgTag + '</a>'
          + '<div class="wishlist-card__info">'
          + '<a href="' + p.url + '" class="wishlist-card__title">' + escapeHtml(p.title) + '</a>'
          + '<p class="wishlist-card__price">' + price + '</p>'
          + '<div class="wishlist-card__actions">'
          + '<a href="' + p.url + '" class="button button--primary">Voir le produit</a>'
          + '<button type="button" class="button button--ghost wishlist-card__remove" data-wishlist-btn="' + p.handle + '" aria-label="Retirer des favoris" aria-pressed="true">'
          + heartIcon(true) + '</button>'
          + '</div>'
          + '</div>'
          + '</div>';
      });

      if (!anyValid && emptyEl) emptyEl.removeAttribute('hidden');
      gridEl.innerHTML = html;
      renderButtons();
    });
  }

  function heartIcon(filled) {
    return filled
      ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>'
      : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>';
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /* ── Init ── */
  renderButtons();
  renderCount();

  /* Ré-render après navigation (pour les SPA-like) */
  document.addEventListener('wishlist:updated', function () {
    var p = document.querySelector('[data-wishlist-page]');
    if (p) renderWishlistPage(p);
  });
})();
